// Chakra imports
import { Box, FormLabel, Switch, useColorModeValue } from '@chakra-ui/react';
// Custom components

export default function ToggleButton(props: {
    id?: string;
    label?: string | React.ReactNode;
    isChecked?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    [x: string]: any;
}) {
    const { id, label, isChecked, onChange, ...rest } = props;
    // Chakra Color Mode
    const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
    
    return (
        <Box w='100%' fontWeight='500' {...rest}>
            <FormLabel
                display='flex'
                ms='10px'
                htmlFor={id}
                fontSize='sm'
                color={textColorPrimary}
                fontWeight='bold'
                _hover={{ cursor: 'pointer' }}
            >
                {label}
            </FormLabel>
            <Switch
                ms='10px'
                id={id}
                variant='main'
                colorScheme={isChecked ? 'green' : 'red'} // Cambia el color según el estado
                size='sm'
                isChecked={isChecked}
                onChange={onChange}
                sx={{
                    '& .chakra-switch': {
                        width: '120px',
                        height: '44px'
                    },
                    '& .chakra-switch__track': {
                        width: '60px',
                        height: '40px',
                        borderRadius: '22px',
                        backgroundColor: isChecked ? 'green.400' : 'red.400', // Fondo verde/rojo
                    },
                    '& .chakra-switch__thumb': {
                        width: '32.5px',
                        height: '30.5px',
                        borderRadius: '50%',
                        marginLeft: '1px',
                        backgroundColor: 'white',
                    }
                }}
            />
        </Box>
    );
}